import {
  FC,
  useMemo,
  useState,
  ReactNode,
  useContext,
  createContext,
} from "react";
import { Helmet } from "react-helmet";

interface SeoContextProps {
  meta: MetaProps | undefined;
  title: string;
  setMeta: (meta: MetaProps) => void;
  setTitle: (title: string) => void;
  description: string;
  setDescription: (description: string) => void;
}

interface MetaProps {
  [key: string]: string;
}

const SEOContext = createContext<SeoContextProps | undefined>(undefined);

interface ProviderProps {
  children: ReactNode;
}

export const SeoProvider: FC<ProviderProps> = ({ children }) => {
  const [meta, setMeta] = useState<MetaProps | undefined>(undefined);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const value = useMemo(
    () => ({ title, description, meta, setTitle, setDescription, setMeta }),
    [title, description, meta],
  );

  return (
    <SEOContext.Provider value={value}>
      <Helmet
        titleTemplate="%s | Edusogno"
        defaultTitle="Welcome to our academy"
      >
        <title>{title}</title>

        <meta name="description" content={description}></meta>

        {meta &&
          Object.keys(meta).map((key) => (
            <meta key={key} name={key} content={meta[key]} />
          ))}
      </Helmet>

      {children}
    </SEOContext.Provider>
  );
};

/* eslint-disable react-refresh/only-export-components */
export const useSEO = () => {
  const context = useContext(SEOContext);

  if (context === undefined) {
    throw new Error("useSEO must be used within an SeoProvider");
  }

  return context;
};
